import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { QuickstartProvider } from "./Context";
import reportWebVitals from "./reportWebVitals";
import { preloadHeroImage } from "./utils/preloadImages";

// 🔇 Suppress ResizeObserver loop noise globally
const resizeObserverErr = /ResizeObserver loop completed|ResizeObserver loop limit exceeded/;
const origError = console.error.bind(console);

console.error = (...args: any[]) => {
  if (args.length && typeof args[0] === "string" && resizeObserverErr.test(args[0])) {
    return; // swallow only ResizeObserver loop errors
  }
  origError(...args);
};

window.addEventListener("error", (e) => {
  if (
    e.message === "ResizeObserver loop completed with undelivered notifications." ||
    e.message === "ResizeObserver loop limit exceeded"
  ) {
    e.stopImmediatePropagation();
  }
});

preloadHeroImage();

ReactDOM.render(
  <React.StrictMode>
    <QuickstartProvider>
      <App />
    </QuickstartProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

reportWebVitals();
